import React, { Component } from "react";
import styled from "styled-components";

import {NumberToColorDict} from "./ColorToNumberDict"

// props to pass in: 
// boardState value - a number array of length 181. as default you may pass Array(181).fill(0)
// NumberedBoard - to get an empty board or a numbered board

class StaticBoard extends Component {
  constructor(props) {
    super(props);
 }




  render() {
    return (
      <Container>
	  
        <svg viewBox="0 0 1080 750">
          {[0,1,2,3,4,5,6,7,8].map(i => {
            return [0,1,2,3,4,5,6,7,8,9].map(j => {
              return (
                <>
				
                  <StaticHexagon
                    number={2*i + j * 18 + 1}
					fill = {NumberToColorDict[this.props.boardState[2*i + j * 18 + 1]]} 
                    transform={"translate(" + 100 * i + "," + 60 * j + ")"}
					NumberedBoard = {this.props.NumberedBoard}
					boardState = {this.props.boardState}
					
                  />
                  <StaticHexagon 
                    number={2*i + j * 18 + 2}
                    fill = {NumberToColorDict[this.props.boardState[2*i + j * 18 + 2]]} 
                    transform={"translate(" + (100 * i + 50) + "," + (j * 60 + 30) + ")"}
					NumberedBoard = {this.props.NumberedBoard}
					boardState = {this.props.boardState}
					
					
                  /> 
                </> 
              );
            });
          })}
        </svg>
		
			
      </Container>
    );
  }
}

export default StaticBoard;

const Container = styled.div`
  margin-left: -1em;
`;


class StaticHexagon extends Component {
  constructor(props) {
    super(props); 
	this.state = {
		hexagonStyle : {
			fill: this.props.fill,
			stroke: "black",
			strokeWidth: "2",
		  },
			  
	}
	
	this.textStyle = (this.state.hexagonStyle.fill==="black") ? {fill: "white"} : {fill: "black"};
	// this.showNumber = (this.props.NumberedBoard)? (this.props.number) : (null)
	
	
	this.fontContrast = this.fontContrast.bind(this)
    };
    
	//cahnge the font to white if the tile is black
	fontContrast = () =>{
		if (this.props.fill === "black"){ return ("white")} else {return ("black")};
	}
	
	//if the boardState was update - then update the hexagonStyle and textFill
	//when the user put taskId in the login the boardState is updated
	componentDidUpdate(prevProps) {
		if (this.props.boardState !== prevProps.boardState) {
		this.setState({hexagonStyle:{...this.state.hexagonStyle, fill:this.props.fill}});
		
		}
	}



  render() {
		
    return (
	
	  <g
        transform={this.props.transform}
      >
        <polygon
          id="hexagon"
          points= "60,70 90,50 120,70 120,100 90,120 60,100"
		  transform = "rotate (90 90 85)"
          style= {this.state.hexagonStyle}
		 
        />
        <text
          text-anchor="middle"
          x="90"
          y="93"
          font-size="25"
          style= {{fill:this.fontContrast()}}  //{this.state.textFill}
        >
		{(this.props.NumberedBoard)? (this.props.number) : (null)}
		
        
		</text>
      </g>
    );
  }
}



